import { render, staticRenderFns } from "./PDPFilter.vue?vue&type=template&id=0a312118&scoped=true&"
import script from "./PDPFilter.vue?vue&type=script&lang=js&"
export * from "./PDPFilter.vue?vue&type=script&lang=js&"
import style0 from "./PDPFilter.vue?vue&type=style&index=0&id=0a312118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a312118",
  null
  
)

export default component.exports